import FailedSVG from './components/FailedSvg'
import { ayeTexts } from '../../../utils/constant'
import backgroundImage from '../../../assets/background.jpg'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function FailedScreen() {
  const navigate = useNavigate()

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/login')
    }, 5000)

    return () => clearTimeout(timeout)
  }, [navigate])

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}>
      <div className="mt-4 flex w-full flex-col items-center justify-center">
        <FailedSVG />
      </div>
      <div className="failed-body">
        <div className="failed-bottom">
          <div className="instruction p-10">
            <p className="max-w-lg text-center text-[0.9rem]">
              To enable Facial Recognition Payment, please ensure to check the
              box for 'Save my cards for the next purchase' on the next Razer
              Merchant Services page.
            </p>
          </div>
          {/* <div className="save-image">
            <img
              src={require('../../../assets/save_card.png')}
              alt="Save card instruction"
              width={300}
              height={50}
            />
          </div> */}
        </div>
      </div>

      <div className="flex gap-2">
        <button
          type="button"
          className="w-36 rounded-2xl bg-[#5CB891] px-8 py-2 text-white">
          {ayeTexts.failed_screen.try_again_button}
        </button>
        <button
          type="button"
          className="w-36 rounded-2xl border-2 border-[#5CB891] bg-white px-8 py-2 text-[#5CB891]">
          {ayeTexts.failed_screen.cancel_button}
        </button>
      </div>
    </div>
  )
}
